import React, {Fragment, useEffect, useRef, useState} from 'react';
import SwitchableMessageText from "./SwitchableMessageText";
import {useTranslation} from "react-i18next";
import {message} from "antd";

const ListMessages = ({id, msg, msData, selectedItems, setSelectedItems, messagesList}) => {
	const {t} = useTranslation();
	const checkboxRef = useRef(null);
	const [checked, setChecked] = useState(Boolean(selectedItems.find((item) => item.id === msg?.id)));

	const handleCheckboxChange = () => {
		setSelectedItems((prevItems) => {
			if (prevItems.find((item) => item.id === msg?.id)) {
				return prevItems.filter((item) => item.id !== msg?.id);
			} else {
				return [...prevItems, msg];
			}
		});
	};

	useEffect(() => {
		setChecked(Boolean(selectedItems.find((item) => item.id === msg?.id)));
	}, [selectedItems]);

	return (
			<Fragment>
				{msg?.type === 'post' ? (
						<div
								className={
									`relative w-full py-2 px-4 rounded-lg mt-2.5 mb-0.5 shadow-lg border 
										${msData?.role === "assistant" ? "bg-white text-primary  fade-in-from-left" : "bg-primary text-white ml-auto fade-in-from-right"}`
								}
						>
							<div
									className='mb-1 border-b flex items-center justify-between gap-2 cursor-pointer'
									onClick={() => checkboxRef.current.click()}
							>
								<h5 className='text-md font-semibold line-clamp-1'>
									{msg?.title}
								</h5>
								<div className='flex items-center gap-1'>
									<h5
										className={`flex items-center gap-1.5 text-nowrap text-center text-lg font-semibold ${checked ? 'text-violet-500' : 'text-gray-400'}`}
									>
										{t('assistant.post.postTitle')}
									{checked ? (
											<span className='border-gray-200 bg-violet-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-sm font-normal'>
												{selectedItems.findIndex((item) => item.id === msg?.id) + 1}
											</span>
											): (
													<span className='border border-gray-200 bg-gray-100 text-white rounded-full w-5 h-5 flex items-center justify-center text-sm font-normal'/>
									)}
									</h5>

									<input
											hidden
											className='!hidden'
											ref={checkboxRef}
											checked={checked}
											onChange={handleCheckboxChange}
											type='checkbox'
									/>
								</div>
							</div>
							<SwitchableMessageText id={id} title={msg?.title ?? ''} hashtags={msg?.hashtags ?? []} message={msg?.content ?? ''} messagesList={messagesList}/>
						</div>
				) : (
						<div
								className={
									`relative w-full py-2 px-4 rounded-lg mt-2.5 mb-0.5 shadow-xl border 
									${msData?.role === "assistant" ? "bg-white text-primary fade-in-from-left" : "bg-primary text-white ml-auto fade-in-from-right"}`
								}
						>
									<pre className='block text-wrap text-pretty max-w-full font-inherit text-inherit'>
										{msg.content}
									</pre>
						</div>
				)}
			</Fragment>
	);
};

export default ListMessages;